// removed by extract-text-webpack-plugin
module.exports = {"ListFeatured":"_1jQk4WSKIGHzlGh2A2Xmgb","ListFeaturedDark":"_2bF8Iz8CW5GQpsgxisoUYC _1jQk4WSKIGHzlGh2A2Xmgb","headerBold":"_3WdAHZR7en-vVQ_B6I_eAn","headerLight":"_36fU3NN5hiKW-jfrzh0HF2","list":"_3W-3VZJd0nyADT4DjBm3fj","buttonNext":"_9PO2dOd_XtQ2c1pAfXc-k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ListFeatured/ListFeatured.css
// module id = 390
// module chunks = 8